"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4507],{

/***/ 94507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MainDialog": function() { return /* binding */ MainDialog; },
/* harmony export */   "Transition": function() { return /* binding */ Transition; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54776);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64666);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lang_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61671);
/* harmony import */ var _theme_typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43795);
/* harmony import */ var zustand_shallow__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60374);
/* harmony import */ var _logic_state_dialog__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36343);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);









// TODO: apply transition to this component without causing freezing issue
var Transition = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function Transition(props, ref) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        direction: "left",
        in: true,
        ref: ref
    }, props));
});
var MainDialog = function(param) {
    var children = param.children;
    var dialog = (0,_logic_state_dialog__WEBPACK_IMPORTED_MODULE_4__/* .useDialog */ .R)(function(s) {
        return s.dialog;
    }, zustand_shallow__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z);
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().locale;
    var dir = (0,_lang_utils__WEBPACK_IMPORTED_MODULE_2__/* .getDirection */ .Mg)(locale);
    var ref;
    return (dialog === null || dialog === void 0 ? void 0 : dialog.wrapper) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        open: (ref = dialog === null || dialog === void 0 ? void 0 : dialog.wrapper) !== null && ref !== void 0 ? ref : false,
        TransitionComponent: Transition,
        dir: dir,
        PaperProps: {
            sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                minHeight: {
                    tablet: (dialog === null || dialog === void 0 ? void 0 : dialog.tabletMinHeight) || (0,_theme_typography__WEBPACK_IMPORTED_MODULE_3__/* .pxToRem */ .Q)(680)
                }
            }, dialog === null || dialog === void 0 ? void 0 : dialog.minWidth)
        },
        children: children
    });
};


/***/ })

}]);